import { fetchFactory } from 'isotope-client'

export const creerCandidat = (data) => fetchFactory('/candidats', {
	method: 'post',
	body: JSON.stringify(data)
}, '/api')
